/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/static-property-placement */
import cx from 'classnames';
import compose from 'core/libs/helpers/compose.js';
import {hideLoadingBar, showLoadingBar} from 'core/libs/loadingBar';
import CheckBox from 'modules/common/CheckBox';
import LoadingIndicator from 'modules/common/LoadingIndicator';
import NewDesignButton from 'modules/common/NewDesignButton';
import NextButton from 'modules/common/NextButton';
import Collapse from 'modules/common/Svg/Collapse';
import Expand from 'modules/common/Svg/Expand';
import False from 'modules/common/Svg/False';
import InfoCircle from 'modules/common/Svg/InfoCircle';
import True from 'modules/common/Svg/True';
import Tooltip from 'modules/common/Tooltip';
import PropTypes from 'prop-types';
import React, {Component, lazy, Suspense} from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import CommunityContent from './CommunityContent';
import HelpContent from './HelpContent';
import OutputCode from './OutputCode';
import QuestionContent from './QuestionContent';
import {
  bgBlackboard,
  bgCodeLight,
  bgGreen,
  bgRed,
  currentFileTab,
  EditorHeight,
  fileTab,
  mainlyBlue,
  marginTabs,
  redBtn,
  TopTab,
} from './styles.scss';

const Editor = lazy(() => import('modules/common/Editor'));

class CodeChallengeTask extends Component {
  constructor(props) {
    super(props);
    this.state = this.createState(props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.codeChallengeId !== nextProps.codeChallengeId) {
      this.setState(this.createState(nextProps));
    } else if (this.props.task.id !== nextProps.task.id) {
      this.setState({
        result: undefined,
        checking: false,
      });
      this.processLoadingBar(false);
    }
  }

  createState = (props) => {
    this.processLoadingBar(false);
    return {
      result: undefined,
      checking: false,
      currentDocName:
        props.sourceCodes[0] && props.sourceCodes[0].node.fileName,
      codes: {},
      shown: false,
      fullscreen: false,
      responseStatus: undefined,
      responseMessage: undefined,
      isHelpUsed: false,
      linter: localStorage.getItem('linter') === 'true',
    };
  };

  checkWork = () => {
    this.setState({
      checking: true,
    });
    this.processLoadingBar();
    const docs = this.editor.getDocs();
    const {id, sourceCodes, task} = this.props;
    const language = sourceCodes[0] && sourceCodes[0].node.language;
    const source_files = Object.entries(docs).map(([fileName, doc]) => {
      let wrapper;
      if (language === 'swift') {
        // Swift emulator need the wrapper
        const currentSource = sourceCodes.find(({node}) => {
          return fileName === node.fileName;
        });
        if (currentSource && currentSource.node.fileContentWrapper) {
          wrapper = window.btoa(currentSource.node.fileContentWrapper);
        }
      }
      return {
        name: fileName,
        wrapper,
        content: window.btoa(
          doc
            .getValue()
            .replace(/\u00A0/g, ' ')
            .replace(
              /[\u00A0-\u2666]/g,
              // source: https://stackoverflow.com/a/33140101/1673761
              (c) => `&#${c.charCodeAt(0)};`,
            ),
        ),
      };
    });

    const codechallenge_id = id;
    const {position, testFiles} = task;
    this.props.checkResult({
      callback: this.updateResult,

      // new emulator
      data: {
        codechallenge_id,
        is_help_used: this.state.isHelpUsed,
        progress_status: this.props.stepProgress,
        is_last_task: this.props.last,
        language,
        position,
        source_files,
        test_files:
          testFiles &&
          testFiles.edges &&
          testFiles.edges.map(({node: {fileContent, fileName}}) => ({
            content: window.btoa(
              fileContent.replace(
                /[\u00A0-\u2666]/g,
                // source: https://stackoverflow.com/a/33140101/1673761
                (c) => `&#${c.charCodeAt(0)};`,
              ),
            ),
            name: fileName,
          })),
        user_pk: this.props.userId,
      },
    });
  };

  preview = () => {
    this.setState(({preview}) => {
      let previewContent;
      if (!preview) {
        const docs = this.editor.getDocs();
        const htmlSourceCode = this.props.sourceCodes.find(
          ({node: {language}}) => language === 'html',
        );
        previewContent = docs[htmlSourceCode.file_name].getValue();
      }
      return {
        preview: !preview,
        previewContent,
      };
    });
  };

  toggleFullScreen = () => {
    this.setState((prevState) => ({
      fullscreen: !prevState.fullscreen,
    }));
  };

  updateResult = ({
    status,
    type,
    // $status: $type
    // Passed
    // Error: Compilation Error | Runtime Error
    // Failed: Assertion Failure
    // Invalid (Error in test files)

    // Error
    column,
    filename,
    line,
    msg,

    // Failed
    hint,

    // legacy emulator
    legacy,
  }) => {
    if (status === 'Connection Error' || status === 'Timeout Error') {
      this.setState({
        checking: false,
        result: undefined,
        responseStatus: undefined,
        responseMessage: undefined,
      });
    } else {
      /*  console.log('RESULT::::', {
        status,
        type,
        column,
        filename,
        line,
        msg,
        hint,
      }); */
      this.setState({
        checking: false,
        result: status === 'Passed',
        responseStatus: status,
        responseMessage: msg,
      });
    }

    this.processLoadingBar(false);
  };

  next = () => {
    this.props.next();
    this.setState({
      result: undefined,
    });
  };

  updateCode = (file_name, code) => {
    this.setState((prevState) => ({
      codes: {
        ...prevState.codes,
        [file_name]: code,
      },
    }));
  };

  tabClick = (e) => {
    e.preventDefault();
    if (this.editor)
      this.editor.changeDoc(this.state.currentDocName, e.currentTarget.name);
    this.setState({currentDocName: e.currentTarget.name});
  };

  clickHelp = () => {
    this.setState({
      isHelpUsed: true,
    });
  };

  toggleLinter = (e) => {
    const linter = e.target.checked;
    this.setState({linter});
    localStorage.setItem('linter', linter);
  };

  processLoadingBar(flag = true) {
    this.props.dispatch(flag ? showLoadingBar() : hideLoadingBar());
  }

  render() {
    const {
      nextStepProps,
      sourceCodes,
      intl: {formatMessage},
    } = this.props;
    const mainLanguage =
      sourceCodes && sourceCodes[0] && sourceCodes[0].node.language;
    const LINTER_LANGUAGES = ['django', 'java', 'python'];
    const isLinterAvailable = LINTER_LANGUAGES.includes(mainLanguage);
    return (
      <div>
        <div className="cf">
          <div className="fr w-30-ns w-100-m w-100 bg-white">
            <QuestionContent
              description={this.props.description}
              task={this.props.task}
              currentPosition={this.props.currentPosition}
              challenges={this.props.challenges}
            />
            <HelpContent
              code_challenge_helper_youtube_id={
                this.props.codeChallengeHelperYoutubeId
              }
              task={this.props.task}
              is_help_used={this.clickHelp}
            />
            <CommunityContent />
          </div>
          <div className="w-70-ns w-100-m w-100 fl bg-white">
            <div
              className={cx(
                'top-0 right-0 w-100 h-100 flex flex-stretch flex-column z-9999',
                {fixed: this.state.fullscreen},
              )}
            >
              {/* tabs */}
              <div
                className={`pr4-ns ltr white ${bgCodeLight} flex flex-column flex-column-reverse flex-row-ns items-center-ns justify-between`}
              >
                {this.state.preview ? (
                  <div className={`fw6 shadow-hover white ${marginTabs}`}>
                    <FormattedMessage id="preview_code" />
                  </div>
                ) : (
                  <div className="flex items-center">
                    {this.props.sourceCodes
                      .filter(({node: {isHidden}}) => !isHidden)
                      .map(({node: {fileName}}, index) => (
                        <a
                          key={index}
                          className={cx('fw4 shadow-hover white ph4', TopTab, {
                            [currentFileTab]:
                              this.state.currentDocName === fileName,
                            [fileTab]: this.state.currentDocName !== fileName,
                          })}
                          name={fileName}
                          onClick={this.tabClick}
                        >
                          {fileName}
                        </a>
                      ))}
                  </div>
                )}
                <div className="pa2 flex items-center justify-between">
                  {isLinterAvailable && (
                    <div className="flex items-center flex-row-ns flex-row-reverse">
                      <Tooltip
                        large
                        className="lh-copy"
                        bottomWhite
                        message={
                          <div>
                            <p className="black">
                              <FormattedMessage id="linter_beta_text" />
                            </p>
                          </div>
                        }
                      >
                        <InfoCircle className="dib v-top pointer grow" />
                      </Tooltip>
                      <div
                        className={`flex items-center dib ph3-ns pv2 ph2 br-pill ${mainlyBlue} f5-ns f7 fw5-ns fw6`}
                      >
                        <div className="lh-solid">
                          <FormattedMessage id="feature_beta_linter" />
                        </div>
                        <CheckBox
                          className="ml3-ns ml2"
                          dark
                          field={{
                            checked: this.state.linter,
                            onChange: this.toggleLinter,
                          }}
                        />
                      </div>
                    </div>
                  )}
                  <NewDesignButton
                    className={`pv2 b--transparent ${mainlyBlue} ml4-ns`}
                    onClick={this.toggleFullScreen}
                  >
                    {this.state.fullscreen ? (
                      <Collapse className="db" />
                    ) : (
                      <Expand className="db" />
                    )}
                  </NewDesignButton>
                </div>
              </div>
              {/* Editor */}
              <div
                className={`relative ltr f4 flex-auto h-100 overflow-auto ${bgBlackboard}`}
              >
                <Suspense fallback={<LoadingIndicator />}>
                  <Editor
                    editorRef={(editor) => {
                      this.editor = editor;
                    }}
                    className={cx(EditorHeight, {dn: this.state.preview})}
                    sourceCodes={this.props.sourceCodes}
                    currentDocName={this.state.currentDocName}
                    taskId={this.props.task.id}
                    codeChallengeId={this.props.codeChallengeId}
                    linter={this.state.linter}
                  />
                </Suspense>
                {this.state.preview && (
                  <div className="ph1">
                    <iframe
                      className="w-100 ba br1 b--near-white"
                      height="291"
                      srcDoc={this.state.previewContent}
                      title="preview"
                    />
                  </div>
                )}
              </div>
              <div
                className={cx('pv3 ph4 tr', bgCodeLight, {
                  [`${bgRed} flex justify-between items-center flex-row-ns flex-column`]:
                    this.state.result !== undefined && !this.state.result,
                  [`${bgGreen} flex justify-between items-center flex-row-ns flex-column`]:
                    this.state.result !== undefined && this.state.result,
                })}
              >
                <div className="flex items-center flex-row-ns flex-column justify-between">
                  {this.props.sourceCodes.some(
                    ({node: {language}}) => language === 'html',
                  ) && (
                    <NewDesignButton
                      className="pa3-ns bg-green-light bg-animate hover-bg-green"
                      onClick={this.preview}
                    >
                      {formatMessage({
                        id: this.state.preview
                          ? 'return_to_editor'
                          : 'preview_code',
                      })}
                    </NewDesignButton>
                  )}
                  <div className="flex items-center flex-row-ns flex-column justify-between">
                    {this.props.last && this.state.result && (
                      <NextButton
                        className="pv3"
                        {...nextStepProps}
                        pretext={`${formatMessage({
                          id: 'next_challenge',
                        })} :`}
                      />
                    )}
                    {!this.props.last && this.state.result && (
                      <NewDesignButton
                        className="pa3-ns mb0-ns mb3 bg-green-light bg-animate hover-bg-green"
                        onClick={this.next}
                      >
                        {formatMessage({
                          id: `${
                            this.props.last ? 'next_challenge' : 'new_task'
                          }`,
                        })}
                      </NewDesignButton>
                    )}
                    {!this.state.result && (
                      <NewDesignButton
                        className={cx('pa3-ns mb0-ns mb3', {
                          [redBtn]:
                            this.state.result !== undefined &&
                            !this.state.result,
                          'bg-green-light bg-animate hover-bg-green':
                            this.state.result === undefined,
                        })}
                        active={!this.state.checking}
                        colored
                        onClick={this.checkWork}
                      >
                        {this.state.result === undefined
                          ? `${formatMessage({
                              id: 'check_work',
                            })}`
                          : `${formatMessage({
                              id: 'recheck_work',
                            })}`}
                      </NewDesignButton>
                    )}
                    {this.props.is_admin && (
                      <a
                        href={`${process.env.GATSBY_ADMIN_URL}/school/codechallenge/${this.props.codeChallengeId}/change/`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mh3 pa3-ns fw6 white pv2 bw1 dib no-underline tc br2 white pv2 fw6 ph2 b--white mb0-ns mb3"
                      >
                        <FormattedMessage id="admin_edit" />
                      </a>
                    )}
                  </div>
                </div>
                {this.props.last &&
                this.state.result &&
                this.props.showScore ? (
                  <div className="flex items-center white mb0-ns mb0-m mb3">
                    <True className="ml2 br-100" color="#60ca91" />
                    <span className="flex items-center">
                      {formatMessage({id: 'received_points'})}
                      <span className="mh1">
                        {this.state.isHelpUsed ? 10 : 20}
                      </span>
                      {formatMessage({
                        id: this.state.isHelpUsed ? 'points_min' : 'points_max',
                      })}
                    </span>
                  </div>
                ) : (
                  this.state.result !== undefined &&
                  this.state.checking !== true &&
                  (this.state.result ? (
                    <div className="flex items-center white mb0-ns mb0-m mb3">
                      <True className="ml2 br-100" color="#60ca91" />
                      {formatMessage({id: 'answer_correct'})}.
                    </div>
                  ) : (
                    <div className="flex items-center white mb0-ns mb0-m mb3">
                      <False className="ml2 br-100" color="#fa6d63" />
                      {formatMessage({id: 'answer_incorrect'})}.
                    </div>
                  ))
                )}
              </div>
              {this.props.is_admin && !this.state.result && (
                <OutputCode
                  outputContent={
                    !this.state.responseMessage ? (
                      <div className="pv4 pl4 mr2 gray">
                        <FormattedMessage id="output_empty" />
                      </div>
                    ) : (
                      <div
                        className="pt3 ph3 gray bb b--light-gray"
                        style={{
                          backgroundColor: '#f4f4f4',
                          direction: 'ltr',
                        }}
                      >
                        <h3 className="tc">{this.state.responseStatus}</h3>
                        <pre
                          className="h5"
                          style={{overflowX: 'auto', overflowY: 'auto'}}
                        >
                          <code>{this.state.responseMessage}</code>
                        </pre>
                      </div>
                    )
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CodeChallengeTask.propTypes = {
  dispatch: PropTypes.func.isRequired,
  nextStepProps: PropTypes.object.isRequired,
  is_admin: PropTypes.bool,
  last: PropTypes.bool.isRequired,
  next: PropTypes.func.isRequired,
  sourceCodes: PropTypes.array.isRequired,
  task: PropTypes.object.isRequired,
  codeChallengeId: PropTypes.node.isRequired,
  checkResult: PropTypes.func.isRequired,
  codeChallengeHelperYoutubeId: PropTypes.string,
  currentPosition: PropTypes.number.isRequired,
  challenges: PropTypes.array.isRequired,
  description: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  stepProgress: PropTypes.string.isRequired,
  showScore: PropTypes.bool.isRequired,
  userId: PropTypes.number,
  intl: PropTypes.object,
};

const mapStateToProps = ({user: {profile}}) => ({
  is_admin: profile.data.is_admin,
});

const enhance = compose(connect(mapStateToProps), injectIntl);

export default enhance(CodeChallengeTask);
